import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { mapValues, groupBy } from 'lodash';
import { Map } from 'immutable';

import { colourWhite, colourPrimary, colourPrimaryLight, colourBlack, colourMasterDarker, colourMaster, colourMasterSemiLight } from 'Styles/colors.css';
import { setSelectBoxOpen } from 'Actions/UIActions';
import Select from 'SharedComponents/WveInputs/style';

const MULTIPLE = 'multiple';

const SelectContainer = styled.div`
  position: relative;
`;

const StyledSelect = styled(Select)`
  .Select-menu-outer{
    .Select-value {
      background: ${props => props.multi ? colourPrimary : 'inherit'};
      border-radius: 6px;
      border: none;
      color: red;

    }
  }
  .Select-multi-value-wrapper{
    .Select-value {
      background: ${props => props.multi ? colourPrimaryLight : 'inherit'};
      margin-top: ${props => props.multi ? '3px' : 'inherit'};
      border-radius: 6px;
      border: none;
      .Select-value-icon{
        padding: 4px 8px 3px;
        line-height: 20px;
        font-size: 16px;
        border: none;
      }
      .Select-value-label{
        padding: 4px 8px 3px;
        padding: 2px 0px;
        padding-right: 10px;
        line-height: 20px;
        border: none;
      }
    }
  }
  .Select-clear {
    font-size: inherit;
    color: ${colourMasterSemiLight};
  }
`;

const IconOption = styled.div`
  height: 55px;
  line-height: 55px;
  display: flex;
  align-items: center;
  color: red !imporant;

  p {
    letter-spacing: 0.01em;
    color: red !imporant;
  }
`;

class ComponentOptions extends React.Component {
  handleMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  }
  handleMouseEnter = (event) => {
    this.props.onFocus(this.props.option, event);
  }
  handleMouseMove = (event) => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  }
  render() {
    const { children, option } = this.props;
    return (
      <IconOption
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={option.title}
      >
        <span className={`wve-icon wve-icon-primary wve-icon wve-icon-${this.props.option.type} m-l-5 m-r-5`} />
        <div className="m-l-10">
          <p className="wve-m-0 fs-13">{this.props.option.label}</p>
          <p className="wve-m-0 small hint-text">{this.props.option.type}</p>
        </div>
      </IconOption>
    );
  }
}

ComponentOptions.defaultProps = {
  className: '',
  isDisabled: false,
  isFocused: false,
  isSelected: false,
  onFocus: () => {},
  onSelect: () => {},
};

ComponentOptions.propTypes = {
  children: React.PropTypes.node.isRequired,
  className: React.PropTypes.string,
  isDisabled: React.PropTypes.bool,
  isFocused: React.PropTypes.bool,
  isSelected: React.PropTypes.bool,
  onFocus: React.PropTypes.func,
  onSelect: React.PropTypes.func,
  option: PropTypes.objectOf(PropTypes.object).isRequired,
};

const formattedOptions = (options, values) => {
  const formmatedOptions = [];

  [...options].forEach((o, i) => {
    const value = values[i] ? values[i] : o;
    formmatedOptions.push({ key: o, label: o, value });
  });
  return formmatedOptions;
};

const iconFormattedOptions = options => options.map(o => ({ key: o[0], value: o[0], label: o[0], type: o[1] }));

class WveInputSelect extends Component {
  multipleOption = () => {
    const { value } = this.props;
    const isMultiple = value === MULTIPLE;
    if (isMultiple) {
      return (<option key="defopt" value="" disabled selected hidden>{MULTIPLE}</option>);
    }
    return null;
  };
  handleOpen = () => {
    const { setSelectBoxOpen } = this.props;
    setSelectBoxOpen(true);
  };

  handleClose = () => {
    const { setSelectBoxOpen } = this.props;
    setSelectBoxOpen(false);
  };
  renderOption = option => (option.renderOption
    ? option.renderOption(option, this.props)
    : <option value={option.value}>{option.key}</option>)

  // renderOption = option => (<div>{option.value} - {option.label} - {option.someOtherValue}</div>);

  renderValue = option => (option.renderValue
    ? option.renderValue(option, this.props)
    : option.key)

  // renderMenu = (args) => {
  //   const options = [...args.options];
  //
  //   const selectableOptions = options
  //     .filter(option => !unselectableOptions.includes(option))
  //     .filter(
  //       option => !(option === ALL_KEYFRAMES && this.selectableKeyframes().count() <= 1),
  //     );
  //
  //   return defaultMenuRenderer({ ...args, ...{ options: selectableOptions } });
  // }
  render() {
    const { value, classes = '', className = '', multi, searchable, clearable, onChange, values, options, disabled = false } = this.props;

    const isOptionsArray = Array.isArray(options[0]);

    const selectOptions = isOptionsArray ? iconFormattedOptions(options) : formattedOptions(options, values);

    const optionComponent = isOptionsArray ? { optionComponent: ComponentOptions } : {};

    return (
      <SelectContainer
        disabled={disabled}
        className={`wve-form-item ${classes} ${className}`}
      >
        <StyledSelect
          onChange={onChange}
          defaultValue={selectOptions[0]}
          value={value}
          disabled={disabled}
          multi={multi}
          searchable={searchable}
          clearable={clearable}
          valueRenderer={this.renderValue}
          hideSelectedOptions
          options={selectOptions}
          {...optionComponent}
        />
      </SelectContainer>
    );
  }
}

WveInputSelect.defaultProps = {
  values: [],
  classes: '',
  className: '',
  multi: false,
  searchable: false,
  clearable: false,
  disabled: false,
};

WveInputSelect.propTypes = {
  classes: PropTypes.string,
  className: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  multi: PropTypes.bool,
  searchable: PropTypes.bool,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  setSelectBoxOpen: (open) => {
    dispatch(setSelectBoxOpen(open));
  },
});

export default connect(null, mapDispatchToProps)(WveInputSelect);



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveInputSelect/WveInputSelect.jsx